import { render, staticRenderFns } from "./media-wrap.vue?vue&type=template&id=c7b96e18&scoped=true&"
import script from "./media-wrap.vue?vue&type=script&lang=ts&"
export * from "./media-wrap.vue?vue&type=script&lang=ts&"
import style0 from "./media-wrap.vue?vue&type=style&index=0&id=c7b96e18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b96e18",
  null
  
)

export default component.exports